import { render, staticRenderFns } from "./Replacement.vue?vue&type=template&id=0386753c&scoped=true"
import script from "./Replacement.vue?vue&type=script&lang=js"
export * from "./Replacement.vue?vue&type=script&lang=js"
import style0 from "./Replacement.vue?vue&type=style&index=0&id=0386753c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0386753c",
  null
  
)

export default component.exports